// removed by extract-text-webpack-plugin
module.exports = {"root":"root_ntURc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Title/style.css
// module id = 181
// module chunks = 0